import { checkboxSizes } from "@insite/mobius/Checkbox";
import merge from "lodash/merge";

merge(checkboxSizes, {
    default: {
        iconSize: 18,
        fontSize: 14,
        borderRadius: 3,
    },
    small: {
        iconSize: 16,
        fontSize: 13,
        borderRadius: 2,
    },
});
